import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69cee97fc3f8480013a5a84c/stylesyndicate/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/home/ubuntu/download/69cee97fc3f8480013a5a84c/stylesyndicate/src/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69cee97fc3f8480013a5a84c/stylesyndicate/src/styles/tailwind.css");
